import { useContext, useEffect, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { GlobalStateContext } from "../../layouts/GlobalStates";
import {
    getFeedbackSectionPath,
    resolveDefaultFeedbackSection,
} from "../feedbackPageNavigation";

export default function useDefaultFeedbackTabRedirect() {
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const { feedbackAppGlobalState } = useContext(GlobalStateContext);
    const [result] = feedbackAppGlobalState;
    const redirectedRef = useRef(false);

    useEffect(() => {
        if (!id || !result?.ajax?.item || redirectedRef.current) {
            return;
        }

        const segments = location.pathname.split("/").filter(Boolean);
        const feedbackIndex = segments.indexOf("feedback");
        const sectionSegment =
            feedbackIndex >= 0 ? segments[feedbackIndex + 1] : null;

        const isBareDetailsRoute =
            segments.length === feedbackIndex + 2 &&
            sectionSegment === id;

        if (!isBareDetailsRoute) {
            return;
        }

        const defaultSection = resolveDefaultFeedbackSection(result.ajax);
        if (defaultSection === "details") {
            return;
        }

        if (
            defaultSection === "market" &&
            !result.ajax.item?.menu_exist
        ) {
            return;
        }

        redirectedRef.current = true;
        navigate(getFeedbackSectionPath(defaultSection, id), {
            replace: true,
        });
    }, [id, location.pathname, navigate, result?.ajax, result?.ajax?.item]);
}
